export const HELLO_WORLD = 'HELLO_WORLD'
export const FETCH_START = 'FETCH_START'
export const ERROR_OCCURED = 'ERROR_OCCURED'
export const NETWORK_ERROR_OCCURED = 'NETWORK_ERROR_OCCURED'
export const PRIVATE_ACCOUNT_ERROR = 'PRIVATE_ACCOUNT_ERROR'
export const FETCH_END = 'FETCH_END'

export const FETCH_USER_INFO = 'FETCH_USER_INFO'
export const FETCH_USER_INFO_SUCCESS = 'FETCH_USER_INFO_SUCCESS'
export const FETCH_USER_DATA = 'FETCH_USER_DATA'
export const FETCH_USER_DATA_SUCCESS = 'FETCH_USER_DATA_SUCCESS'
